import React, { useEffect } from 'react';
import { replaceByLinkEnv } from 'services/formatter';
import useEnv from 'hooks/useEnv';
import { useMediaServer } from 'hooks/useMediaServer';
import { SHIPPING_TAB_CONTENT_HTML } from 'settings/productV2';
import styles from './ProductShipping.module.scss';

/**
 * Product page of website. Contains shipping product data.
 */
function ProductShipping({
  handleContentHeight,
}: {
  handleContentHeight?: () => void;
}): JSX.Element {
  const { mediaProductSheet } = useEnv();
  const htmlContent = useMediaServer(
    mediaProductSheet + '/' + SHIPPING_TAB_CONTENT_HTML
  );

  useEffect(() => {
    if (typeof handleContentHeight === 'function') handleContentHeight();
  }, [htmlContent.content]);

  if (!htmlContent.content) {
    return <></>;
  }

  return (
    <>
      <div
        className={styles.productShipping}
        dangerouslySetInnerHTML={{
          __html: replaceByLinkEnv(htmlContent.content),
        }}
      />
    </>
  );
}

export default ProductShipping;
